"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREVIOUS_SAAS_TRACKING_MAP = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var interfaces_1 = require("@hudled/interfaces");
var material_1 = require("@mui/material");
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var RadioSelect_1 = __importDefault(require("shared/components/Form/RadioSelect"));
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var validators_1 = require("utils/form/validators");
var general_1 = require("utils/general");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var utils_1 = require("./utils");
var WizardParts_1 = require("./WizardParts");
exports.PREVIOUS_SAAS_TRACKING_MAP = {
    SPREADSHEET: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Spreadsheet ", (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption" }, { children: "(Excel, Google Sheets, Airtable)" }))] }),
    COMPANY_WIKI: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Company wiki ", (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption" }, { children: "(Notion, Confluence, SharePoint)" }))] }),
    ACCOUNTING_SYSTEM: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Accounting system ", (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption" }, { children: "(P&L, General ledger and/or Creditors)" }))] }),
    NONE: 'We don’t keep track',
    DK: 'I don’t know',
    OTHER: 'Other',
};
var PREVIOUS_SAAS_TRACKING_OPTIONS = (0, general_1.makeValueLabelArray)(interfaces_1.PREVIOUS_SAAS_TRACKING, exports.PREVIOUS_SAAS_TRACKING_MAP);
var FIELDS = ['previousSaasTracking', 'previousSaasTrackingOther'];
var TrackSoftware = function () {
    var formValues = (0, react_final_form_1.useFormState)({ subscription: { values: true } }).values;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var team = (0, react_redux_1.useSelector)(single_1.selectMyCompanyTeam);
    var saveAsTeam = !(0, end2end_1.userCan)(interfaces_1.ACCESS_LEVEL.Owner)(profile) && team;
    var _a = __read((0, hooks_1.useSubmitter)('companies', company === null || company === void 0 ? void 0 : company.id), 1), companySubmitter = _a[0];
    var _b = __read((0, hooks_1.useSubmitter)('company_teams', team === null || team === void 0 ? void 0 : team.id), 1), teamSubmitter = _b[0];
    var formGroup = saveAsTeam ? 'team' : 'company';
    var submit = saveAsTeam
        ? (0, utils_1.submitOnChange)(formValues[formGroup], team, teamSubmitter, FIELDS)
        : (0, utils_1.submitOnChange)(formValues[formGroup], company, companySubmitter, FIELDS);
    return ((0, jsx_runtime_1.jsx)(WizardParts_1.StepTemplate, __assign({ onBeforeNext: submit, isNextDisabled: !formValues[formGroup].previousSaasTracking
            || (formValues[formGroup].previousSaasTracking === 'OTHER' && !formValues[formGroup].previousSaasTrackingOther) }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", flexDirection: "column", height: "100%", width: "100%" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 4 }, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "How do you currently track subscriptions?" })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 2, pb: 4 }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, { children: "This will help us tailor a better experience for you." }) })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ my: 2 }, { children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "".concat(formGroup, ".previousSaasTracking"), component: RadioSelect_1.default, options: PREVIOUS_SAAS_TRACKING_OPTIONS, label: "Software tracking methods" }), formValues[formGroup].previousSaasTracking === 'OTHER' && ((0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "".concat(formGroup, ".previousSaasTrackingOther"), color: "secondary", component: TextField_1.default, validate: (0, validators_1.required)(), label: "Please specify", disabled: !(formValues[formGroup].previousSaasTracking === 'OTHER') }))] }))] })) })));
};
exports.default = TrackSoftware;
